import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Link } from 'components/core/Link';
import { Text } from 'components/core/Typography';
import { getNumericalValue } from 'utils/format';

import FeeWarningToolTip from 'components/fees/FeeWarningToolTip';

import './unitPrice.scss';


export class UnitPrice extends PureComponent {
	static propTypes = {
		priceValue: PropTypes.number,
		/** The regular price of a unit, if provided it is shown with a strikethrough */
		regularPrice: PropTypes.string,
		/** If the price text should be a link */
		linkedPrice: PropTypes.bool,
		showPeriod: PropTypes.bool,
		link: PropTypes.string,
		size: PropTypes.string,
		priceDollars: PropTypes.string.isRequired,
		priceCents: PropTypes.string.isRequired,
		isScarce: PropTypes.bool,
		unitQuantity: PropTypes.number,
		showFees: PropTypes.bool,
		fees: PropTypes.object
	};

	static defaultProps = {
		linkedPrice: true,
		showPeriod: false,
		size: 'medium',
		showFees: false,
		fees: {}
	};

	_renderPrice() {
		const { priceDollars, priceCents } = this.props;
		if (!this.props.linkedPrice) {
			return (
				<Text
					className={classnames('price', {
						'scarcity-price': this.props.isScarce
					})}
					size={this.props.size}
					last
				>
					${priceDollars}
					<sup className="cents">.{priceCents}</sup>
				</Text>
			);
		}

		return (
			<Link
				href={this.props.link}
				className="price"
				hideBorder
			>
				<Text
					className={classnames('price', {
						'scarcity-price': this.props.isScarce
					})}
					strong
					size={this.props.size}
				>
					${priceDollars}
					<sup className="cents">.{priceCents}</sup>
				</Text>
			</Link>
		);
	}

	_renderRegularPrice() {
		const { regularPrice, priceValue } = this.props;
		if (!regularPrice || getNumericalValue(regularPrice) <= priceValue) {
			return null;
		}

		return (
			<Text className="regular-price" strikethrough last>
				${regularPrice}
			</Text>
		);
	}

	_renderPeriod() {
		if (!this.props.showPeriod) {
			return null;
		}

		return (
			<Text className="payment-period" last>
				per month
			</Text>
		);
	}

	_renderFees() {
		if (!this.props.showFees || !this.props?.fees?.totalFees?.value) {
			return null;
		}

		return (
			<FeeWarningToolTip feeProps={this.props.fees} className="fee-tooltip" />
		);
	}

	render() {
		return (
			<div className="unit-price">
				<div className="scarcity-and-price">
					{this.props.isScarce && (
						<Text className="scarcity-message" last>
							{this.props.unitQuantity} left at
						</Text>
					)}
					{this._renderPrice()}
				</div>
				{this._renderPeriod()}
				{this._renderRegularPrice()}
				{this._renderFees()}
			</div>
		);
	}
}
const EnhancedUnitPrice = (props) => {
	const { price } = props;
	const [dollars, cents] = price.toString().split('.');
	const enhancedProps = {
		priceValue: parseFloat(price.replace(/,/g, '')),
		priceDollars: dollars,
		priceCents: cents || '00',
	};
	return (
		<UnitPrice
			{...props}
			{...enhancedProps}
		/>
	);
};

export default EnhancedUnitPrice;
